export const NUM_CONTRATO_SAFI = 'Nº Contrato SAFI';
export const CHECKBOX = 'checkbox';
export const INPUT = 'input';
export const DROPDOWN = 'dropdown';
